





















































































import Vue from "vue";
import Domain from "@/utilities/Domain";

export default Vue.extend({
  data: () => ({}),
  computed: {
    email() {
      let domain = new Domain();
      return domain.getDomain(window.location.hostname);
    }
  }
});
